import React, { Fragment } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import get from 'lodash/get';
import clsx from 'clsx';
import {
  CircularProgress, FormLabel, TextField, makeStyles,
} from '@material-ui/core';

import styles from './styles';

export default function FormAutoCompleteCombo(props) {
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const getOptionLabelDefaultFn = (option) => get(option, 'name');
  const getOptionSelectedDefaultFn = (option, value) => (value.name === option.name);
  const {
    fieldContainerClass,
    id,
    name,
    data = [],
    selectedValues,
    onChange,
    isMultiple,
    isLoading,
    helperText,
    error,
    inputLabel = '',
    hideLabel,
    getOptionLabel = getOptionLabelDefaultFn,
    getOptionSelected = getOptionSelectedDefaultFn,
  } = props;

  return (
    <div
      className={clsx(fieldContainerClass, classes.fieldContainer)}
      id={id} data-apim-test={id} data-layer7-test={id}
    >
      <div className={classes.formLabelContainer}>
        <FormLabel className={hideLabel && classes.hideFormLabel}>{name}</FormLabel>
      </div>
      <Autocomplete
        id={`${id}-auto-complete-combo`}
        data-apim-test={`${id}-auto-complete-combo`}
        data-layer7-test={`${id}-auto-complete-combo`}
        options={data}
        getOptionLabel={getOptionLabel}
        getOptionSelected={getOptionSelected}
        value={selectedValues}
        multiple={isMultiple}
        filterSelectedOptions
        onChange={(e, value) => onChange(e, value)}
        {...(error && { className: classes.error })}
        classes={{
          root: classes.root,
        }}
        loading={isLoading}
        loadingText={<Fragment><span>Loading...</span><CircularProgress color="inherit" size={20} /></Fragment>}
        renderInput={params => (
          <TextField
            {...params}
            className={classes.textField}
            variant="outlined"
            fullWidth
            label={inputLabel}
            inputProps={{
              ...params.inputProps,
              value: params.inputProps.value || getOptionLabel(selectedValues) || '',
            }}
          />
        )}
      />
      <p className={clsx('MuiFormHelperText-root', classes.helperText, (error && classes.error))}>
        {helperText}
      </p>
    </div>
  );
}

FormAutoCompleteCombo.propTypes = {
  fieldContainerClass: string,
  id: string,
  name: string,
  data: arrayOf(shape({})),
  onChange: func,
  isLoading: bool,
  isMultiple: bool,
  selectedValues: shape({}),
  helperText: string,
  error: bool,
  inputLabel: string,
  hideLabel: bool,
  getOptionLabel: func,
  getOptionSelected: func,
};



// WEBPACK FOOTER //
// ./src/components/FormAutoCompleteCombo/index.js